export default {"src":"/_next/static/media/dog-with-food-hat.0be161ea.svg","height":81,"width":72,"blurWidth":0,"blurHeight":0};